import React from 'react';
import { Icon } from 'antd';
import classNames from 'classnames';
import _ from 'lodash';

import { Typography } from 'app/components/common/typography';
import { ReactComponent as SuccessImage } from 'app/resources/success.svg';
import { ReactComponent as ErrorImage } from 'app/resources/error.svg';

import { MessageType } from './message-type';

import styles from './message.module.scss';

interface Props {
    type: MessageType;
    text: string;
    description?: string | string[];
    className?: string;
}

const Message: React.FC<Props> = (props) => {
    const { type, text, description, className } = props;

    const successType = type === MessageType.SUCCESS;

    const messageClassName = classNames(styles.message, successType ? styles.success : styles.error, className);

    const iconType = successType ? SuccessImage : ErrorImage;

    return (
        <div className={messageClassName}>
            <div className={styles.container}>
                <Icon component={iconType} className={styles.icon} />
                <Typography variant="body1" component="strong">
                    {text}
                </Typography>
            </div>
            {description &&
                _.castArray(description).map((descriptionItem, index) => (
                    <Typography key={index} className={styles.description} variant="body1" component="div">
                        {descriptionItem}
                    </Typography>
                ))}
        </div>
    );
};

export { Message };
